import Vue from 'vue';
import App from './App.vue';
import createRouter from './router';

const path = window.location.pathname;
let base = path.replace(/\/[^/]*$/, '');
base = base.replace(/\/$/, '');

const router = createRouter(base);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
